import React, { useState, useEffect } from 'react'
import ReactMarkdown from 'react-markdown'
import RichTextSection from 'components/cms/RichTextSection'
import Page from 'components/layout/Page'
import PublicPageSkeleton from 'components/layout/pageSkeletons/PublicPageSkeleton'
import BoundedPageTemplate from 'components/layout/pageTemplates/FullPageTemplate/FullPageTemplate'

import webpagesMarkdown from '../../../../WEBPAGES.md'

const WebpageDocsPage = () => {
  const [source, setSource] = useState('')
  useEffect(() => {
    fetch(webpagesMarkdown)
      .then((response) => response.text())
      .then((text) => {
        setSource(text)
      })
  }, [])
  return (
    <Page id="WebpageDocs">
      <PublicPageSkeleton
        renderSearch={false}
        renderBalaenaToolkitAd={false}
        mainContent={
          <BoundedPageTemplate
            mainContent={
              <RichTextSection>
                <ReactMarkdown source={source}></ReactMarkdown>
              </RichTextSection>
            }
          />
        }
      />
    </Page>
  )
}

WebpageDocsPage.displayName = 'WebpageDocsPage'

export default WebpageDocsPage
